import { useState } from 'react';
import { useApp } from '../../Contexts/AppProvider';
import { useTheme } from '../../Contexts/ThemeProvider';

export default function Voucher() {
  const {voucher, onAlert, config} = useApp();
  const {theme} = useTheme();
  const [colorVoucher, setColorVoucher] = useState('lightgray');

  const onCopyVoucher = () => {
    navigator.clipboard.writeText(`${voucher}`);
    onAlert({message: 'Voucher copiado com sucesso!', severity: 'success', autoHideDuration: 2000});
    setColorVoucher(theme?.palette?.primary?.main);
    setTimeout(() => {
      setColorVoucher('lightgray');
    }, 100);
  }

  return (
    <div style={{ paddingBottom: 40}}>
      <div style={{paddingTop: 20, display: 'grid', textAlign: 'center'}}>
        <div>
          Parabéns, você concluiu a primeira parte do processo!<br />
          Use o CUPOM abaixo para se cadastrar no aplicativo n2.<br />
          <br />
        </div>
        <div style={{textAlign: 'center', display: 'unset', padding: 20, borderWidth: 2, borderColor: colorVoucher, borderStyle: 'dashed', fontWeight: 700, fontSize: 30, justifySelf: 'center'}}>
          {voucher || 'carregando...'}
          <img alt='copy' onClick={onCopyVoucher} src="assets/img/copy.png" style={{marginLeft: 10, marginTop: -4, height: 30, width: 30, cursor: 'pointer'}} />
        </div>
        <img src={`${config?.assets?.qrcode}`} alt="Baixe o aplicativo da n2 pela Google Play Store" style={{marginTop: 20, display: 'unset', justifySelf: 'center'}} />
        <div style={{paddingTop: 30}}>
          <a href="https://play.google.com/store/apps/details?id=info.n2app" target="_blank" rel="noreferrer">
            <img src={`${config?.assets?.googleplay}`} alt="Baixe o aplicativo da n2 pela Google Play Store" />
          </a>
          <a href="https://apps.apple.com/br/app/id1499731786" target="_blank" rel="noreferrer">
            <img style={{marginTop: 3}} src={`${config?.assets?.appstore}`} alt="Baixe o aplicativo da n2 pela Apple Store" />
          </a>
        </div>
      </div>
    </div>
  );
}
